import React from 'react';
import { LocationsViewRendererProps } from '../types';

import Desktop from './Desktop';

function ViewRenderer(props: LocationsViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
